<ws-modal-wrapper headerLabel="Set Top Account"
                  acceptLabel="Save"
                  acceptHelpContentId="app.save"
                  cancelHelpContentId="app.cancel"
                  (save)="save()"
                  (cancel)="cancel()">
    <ul>
        @for (item of params.appealFormList; track item) {
            <li>
                <label>
                    <input type="radio" name="formRevisionGroup" [(ngModel)]="topAppealFormRevisionId" [value]="item.appealFormRevisionId"/>
                    <span>{{ item.parcelAcctNum }}</span>
                </label>
            </li>
        }
    </ul>
</ws-modal-wrapper>
